export default {
  getPortalTemplate: {
    method: 'get',
    url: 'template/default'
  },
  uploadPortalTemplate: {
    method: 'post',
    url: 'template/default'
  },
  deletePortalTemplate: {
    method: 'delete',
    url: 'template/default'
  },
  getPortalList: {
    method: 'get',
    url: 'template/portal'
  },
  setPortalDefault: {
    method: 'post',
    url: 'template/portal/default'
  }
}
